// extracted by mini-css-extract-plugin
export default {"container":"Input_container__Mtb4b","label":"Input_label__Dz5N0","input":"Input_input__eXwaT","error_input":"Input_error_input__jHHOn","error":"Input_error__i7Rpt"};